export default __webpack_public_path__ + "static/media/twelve-week-sprint.2b1e15cf.svg";